const home_featured_swiper = new Swiper('.home_featured_carousel', {
    spaceBetween: 24,
    loop: true,
    nested: true,
    watchSlidesProgress: true,
    a11y: {
        enabled: true,
        scrollOnFocus: false,
    },

    navigation: {
        nextEl: '.featured_property_next',
        prevEl: '.featured_property_prev',
    },
    breakpoints: {
        720: {
            slidesPerView: 2,

        },
        1000: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 3,

        },
    },
    on: {
        init(swiper) {
            updateBuildingAccessibility(swiper);
        },
        slideChange(swiper) {
            updateBuildingAccessibility(swiper);
            const current = this.realIndex + 1;
            const total = this.slides.length - this.loopedSlides * 2;
            const message = `Showing 3 of ${total} Featured Properties`;
            const status = document.getElementById('swiper-status');
            status.textContent = message;
        },
        progress(swiper) {
            updateBuildingAccessibility(swiper);
        },
    },

});